import Component from '../abstracts/Component';
import {Zero, Components} from 'Zero';
import {ZFilters} from "StoreLocatorSubcomponents/sl_filters.js";
import {ZSearch} from "StoreLocatorSubcomponents/sl_search.js";
import {ZMap} from "StoreLocatorSubcomponents/sl_map.js";
import {ZResults} from "StoreLocatorSubcomponents/sl_results.js";
import {ZResultsCounter} from "StoreLocatorSubcomponents/sl_results_counter.js";
import {ZStoreLocator} from "StoreLocatorSubcomponents/sl_storelocator.js";

export default class StoreLocatorComponent extends Component {

  render() {
    super.render();
    let _this = this;

    window.InitGoogle = function () {};
    const googleApiKey = $("#googleApiKey").val();
    const googleLanguage = $("#googleLanguage").val();

    const apiUrl = `https://maps.googleapis.com/maps/api/js?v=3.36&key=${googleApiKey}&libraries=places,geometry&callback=InitGoogle&language=${googleLanguage}`;

    this.moduleLoader.loadExternalScript(apiUrl).then(() => {
      window.Zero = Zero;

      Components.create('ZStoreLocator', ZStoreLocator);
      Components.create('ZMap', ZMap);
      Components.create('ZSearch', ZSearch);
      Components.create('ZResults', ZResults);
      Components.create('ZFilters', ZFilters);
      Components.create('ZResultsCounter', ZResultsCounter);

      window.GEO_JSON = {};

      Zero.start( {} );
    });
  }
}
